var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center","align-content":"center"}},[_c('v-col',{attrs:{"cols":"7","xl":"2","lg":"2","md":"3","sm":"4"}},[_vm._v(" ページが存在しません。 ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }